import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class RequestQuoteService {
    // This service is for dynamically triggering the GET APIs of 
    // [CLEARANCE, COPE, POLICY PARAMETER, INDICATION TO QUOTE STEP when AMEND proccess is ACTIVE]
    private targetPremiumHeading$ = new BehaviorSubject<boolean>(false);
    private clearanceStepData$ = new BehaviorSubject<boolean>(false);
    private copeStepData$ = new BehaviorSubject<boolean>(false);
    private policyParameterStepData$ = new BehaviorSubject<boolean>(false);
    private indicationToQuoteStepData$ = new BehaviorSubject<boolean>(false);

    onUpdateTargetPremium(data : boolean){
        this.targetPremiumHeading$.next(data);
    }

    onUpdateClearanceStepData(data: boolean){
        this.clearanceStepData$.next(data);
    }

    onUpdateCopeStepData(data: boolean){
        this.copeStepData$.next(data);
    }

    onUpdatePolicyParameterStepData(data: boolean) {
        this.policyParameterStepData$.next(data);
    }

    onUpdateIndicationToQuoteStepData(data: boolean){
        this.indicationToQuoteStepData$.next(data);
    }

    getClearanceStepData(){
        return this.clearanceStepData$.asObservable();
    }

    getTargetPremiumHeading(){
        return this.targetPremiumHeading$.asObservable();
    }
    getCopeStepData(){
        return this.copeStepData$.asObservable();
    }

    getPolicyParameterStepData(){
        return this.policyParameterStepData$.asObservable();
    }

    getIndicationToQuoteStepData() {
        return this.indicationToQuoteStepData$.asObservable();
    }

    resetTargetPremium(){
        this.targetPremiumHeading$.next(false);
    }

    resetClearanceStepData(){
        this.clearanceStepData$.next(false) // reset to default value;
    }

    resetCopeStepData() {
        this.copeStepData$.next(false); // reset to default value;
    }

    resetPolicyParameterStepData() {
        this.policyParameterStepData$.next(false) // reset to default value;
    }

    resetIndicationToQuoteStepData() {
        this.indicationToQuoteStepData$.next(false);
    }
}